export const pluralize = (count: number, singularForm: string) => {
  if (count === 1) {
    return singularForm;
  }

  if (singularForm.endsWith('y')) {
    return `${singularForm.slice(0, -1)}ies`;
  }

  return `${singularForm}s`;
};
